const mergeClasses = (...classes) => {
  return classes.filter(Boolean).join(" ");
};

export const Button = ({
  label,
  href,
  icon: Icon,
  variant = "default",
  disabled = false,
  full = false,
  size,
  className,
  data = {},
  ...props
}) => {
  const baseStyles = [
    "rounded-md",
    "px-3.5",
    "py-2.5",
    "text-base",
    "font-semibold",
    "inline-flex",
    "items-center",
    "space-x-1",
    "focus-visible:outline",
    "focus-visible:outline-2",
    "focus-visible:outline-offset-2",
    "focus-visible:outline-default-600",
    "[&>svg]:w-4",
    "[&>svg]:h-4",
  ].join(" ");

  const variantStyles = {
    white: "text-default-600 bg-white hover:bg-gray-100 hover:text-defalut-600",
    default: "bg-default-600 text-white",
    light: "bg-default-50 text-default-600 hover:bg-default-100",
  };

  const sizeStyles = {
    small: [
      "text-xs",
      "px-1.5",
      "py-1",
      "space-x-1",
      "text-sm",
      "[&>svg]:pl-[-5px]",
      "[&>svg]:flex-shrink-0",
      "[&>svg]:w-4",
      "[&>svg]:h-4",
    ].join(" "),
    large: [
      "text-lg",
      "px-4",
      "py-3",
      "space-x-2",
      "[&>svg]:pl-[-10px]",
      "[&>svg]:flex-shrink-0",
      "[&>svg]:w-6",
      "[&>svg]:h-6",
    ].join(" "),
  };

  const classes = mergeClasses(
    baseStyles,
    variantStyles[variant],
    disabled && "pointer-events-none opacity-50",
    full && "w-full justify-center",
    size && sizeStyles[size],
    className,
  );

  const dataAttributes = Object.entries(data).reduce((acc, [key, value]) => {
    acc[`data-${key}`] = value;
    return acc;
  }, {});

  const content = (
    <>
      {Icon && <Icon className="flex-shrink-0" />}
      {label && <span className="truncate flex-shrink">{label}</span>}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classes} {...dataAttributes} {...props}>
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={classes}
      disabled={disabled}
      {...dataAttributes}
      {...props}
    >
      {content}
    </button>
  );
};
